import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ErrorService } from '../services/error.service';
import { ResourceBundleService } from '../services/resource-bundle.service';

@Component({
    selector: 'app-error-wrapper',
    templateUrl: './error-wrapper.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ErrorWrapperComponent {
	constructor(public bundleService: ResourceBundleService, public errorService: ErrorService) {}
}
